<template>
  <div class="content">
    <!--    <span>Ông/bà</span>-->
    <span class="highlight font-weight__bold"> {{ publisherName }} </span>
    <span>đã</span>
    <span class="highlight-action">Ban hành </span>
    <span
    >văn bản <strong>số {{ docCode }} </strong>ngày<strong>
        {{ formatDate(docDate) }}
      </strong>
    </span>
    <span> về việc </span>
    <span class="event ">"{{ quote }}"</span>
  </div>
</template>

<script>

  import moment from "moment";

  export default {
    name: "notification-item-banhanhtoi",
    props: ["vbNotificationView"],
    data() {
      return {
        fromActorFullName: null,
        action: null,
        taskTitle: null,
        dataJson: null,
        vbIncomingDoc: null,
      };
    },
    computed: {
      publisherName() {
        return this.vbIncomingDoc ? (this.vbIncomingDoc.publisherName || this.vbIncomingDoc.outsidePublisherName) : null;
      },
      docCode() {
        return this.vbIncomingDoc ? (this.vbIncomingDoc.docCode) : null;
      },
      docDate() {
        return this.vbIncomingDoc ? (this.vbIncomingDoc.docDate) : null;
      },
      quote() {
        return this.vbIncomingDoc ? (this.vbIncomingDoc.quote) : null;
      }
    },
    created() {
      this.initData();
    },
    methods: {
      initData() {
        this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
        this.vbIncomingDoc = this.dataJson.vbIncomingDoc;
      },
      formatDate(value) {
        let date = new moment(value);
        return date.format("DD/MM/YYYY");
      },
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/header/notification-item-banhanhtoi.vue